import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class SettingsValuesService {

  private _SettingsService: any = {};
  private _isInitialized = false;

  public set SettingsService(value: any) {
    this._isInitialized = true;
    this._SettingsService = value;
  }
  public get SettingsService() {
    return this._SettingsService;
  }

  public get isInitialized() {
    return this._isInitialized;
  }

  public get ApplicationName() {
    return this._SettingsService['ApplicationName'];
  }
  public get Debug() {
    return this._SettingsService['Debug'];
  }
  public get FootPrintAPI() {
    return this._SettingsService['FootPrintAPI'];
  }
  public get Instance() {
    return this._SettingsService['Instance'];
  }
  public get MongoDB() {
    return this._SettingsService['MongoDB'];
  }
  public get UltrashipSftp() {
    return this._SettingsService['UltrashipSftp'];
  }

  public app: SettingsValuesService = this;

  public get Ultraship() {
     return {
ApplicationName : this.ApplicationName,
Debug : this.Debug,
FootprintApi : this.FootPrintAPI,
Instance : this.Instance,
MongoDb : this.MongoDB,
UltrashipSftp : this.UltrashipSftp
    };
  }
  public get Utilities() {
     return {
FootPrintAPI : this.FootPrintAPI,
MongoDB : this.MongoDB
    };
  }
}
